export default {
  "head.index": "Startseite"
}